import { ChainId, WBNB, ERC20Token } from '@nominex/nomiswap-sdk'
import { ERC20TokensMap } from './types'

export const tokens: ERC20TokensMap = {
  abra: new ERC20Token(
    ChainId.BSC,
    '0xcA1c644704feBf4ab81f85daca488d1623C28e63',
    18,
    'ABRA',
    'Cadabra Finance',
    'https://cadabra.finance/',
  ),
  ada: new ERC20Token(
    ChainId.BSC,
    '0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47',
    18,
    'ADA',
    'Binance-Peg Cardano Token',
    'https://cardano.org/',
  ),
  alpaca: new ERC20Token(
    ChainId.BSC,
    '0x8F0528cE5eF7B51152A59745bEfDD91D97091d2F',
    18,
    'ALPACA',
    'Alpaca Token',
    'https://alpacafinance.org/',
  ),
  atom: new ERC20Token(
    ChainId.BSC,
    '0x0Eb3a705fc54725037CC9e008bDede697f62F335',
    18,
    'ATOM',
    'Binance-Peg Cosmos Token',
    'https://cosmos.network/',
  ),
  avax: new ERC20Token(
    ChainId.BSC,
    '0x1CE0c2827e2eF14D5C4f29a091d735A204794041',
    18,
    'AVAX',
    'Binance-Peg Avalanche Token',
    'https://avalabs.org',
  ),
  // bnb here points to the wbnb contract. Wherever the currency BNB is required, conditional checks for the symbol 'BNB' can be used
  bnb: new ERC20Token(
    ChainId.BSC,
    '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    18,
    'BNB',
    'BNB',
    'https://binance.com/',
  ),
  btcb: new ERC20Token(
    ChainId.BSC,
    '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    18,
    'BTCB',
    'Binance-Peg BTCB Token',
    'https://bitcoin.org/',
  ),
  busd: new ERC20Token(
    ChainId.BSC,
    '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
    18,
    'BUSD',
    'Binance-Peg BUSD Token',
    'https://paxos.com/busd/',
  ),
  cake: new ERC20Token(
    ChainId.BSC,
    '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    18,
    'CAKE',
    'PancakeSwap Token',
    'https://pancakeswap.finance/',
  ),
  doge: new ERC20Token(
    ChainId.BSC,
    '0xbA2aE424d960c26247Dd6c32edC70B295c744C43',
    8,
    'DOGE',
    'Binance-Peg Dogecoin Token',
    'https://dogecoin.com/',
  ),
  dai: new ERC20Token(
    ChainId.BSC,
    '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
    18,
    'DAI',
    'Binance-Peg Dai Token',
    'https://makerdao.com',
  ),
  dot: new ERC20Token(
    ChainId.BSC,
    '0x7083609fCE4d1d8Dc0C979AAb8c869Ea2C873402',
    18,
    'DOT',
    'Binance-Peg Polkadot Token',
    'https://polkadot.network/',
  ),
  etc: new ERC20Token(
    ChainId.BSC,
    '0x3d6545b08693daE087E957cb1180ee38B9e3c25E',
    18,
    'ETC',
    'Binance-Peg Ethereum Classic',
    'https://ethereumclassic.org/',
  ),
  eth: new ERC20Token(
    ChainId.BSC,
    '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    18,
    'ETH',
    'Binance-Peg Ethereum Token',
    'https://ethereum.org/',
  ),
  fil: new ERC20Token(
    ChainId.BSC,
    '0x0D8Ce2A99Bb6e3B7Db580eD848240e4a0F9aE153',
    18,
    'FIL',
    'Binance-Peg Filecoin Token',
    'https://filecoin.io/',
  ),
  ftm: new ERC20Token(
    ChainId.BSC,
    '0xAD29AbB318791D579433D831ed122aFeAf29dcfe',
    18,
    'FTM',
    'Fantom',
    'https://fantom.foundation',
  ),
  gmt: new ERC20Token(
    ChainId.BSC,
    '0x3019BF2a2eF8040C242C9a4c5c4BD4C81678b2A1',
    8,
    'GMT',
    'Green Metaverse Token',
    'https://stepn.com/',
  ),
  gst: new ERC20Token(
    ChainId.BSC,
    '0x4a2c860cEC6471b9F5F5a336eB4F38bb21683c98',
    8,
    'GST',
    'Green Satoshi Token',
    'https://stepn.com/',
  ),
  link: new ERC20Token(
    ChainId.BSC,
    '0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD',
    18,
    'LINK',
    'Binance-Peg Chainlink Token',
    'https://chain.link/',
  ),
  ltc: new ERC20Token(
    ChainId.BSC,
    '0x4338665CBB7B2485A8855A139b75D5e34AB0DB94',
    18,
    'LTC',
    'Binance-Peg Litecoin Token',
    'https://litecoin.org/',
  ),
  mana: new ERC20Token(
    ChainId.BSC,
    '0x26433c8127d9b4e9B71Eaa15111DF99Ea2EeB2f8',
    18,
    'MANA',
    'Decentraland',
    'https://decentraland.org',
  ),
  matic: new ERC20Token(
    ChainId.BSC,
    '0xCC42724C6683B7E57334c4E856f4c9965ED682bD',
    18,
    'MATIC',
    'Matic Token',
    'https://polygon.technology/',
  ),
  mdao: new ERC20Token(
    ChainId.BSC,
    '0x60322971a672B81BccE5947706D22c19dAeCf6Fb',
    18,
    'MDAO',
    'MarsDAO',
    'https://daomars.com',
  ),
  near: new ERC20Token(
    ChainId.BSC,
    '0x1Fa4a73a3F0133f0025378af00236f3aBDEE5D63',
    18,
    'NEAR',
    'Binance-Peg NEAR Protocol',
    'https://near.org/',
  ),
  nmx: new ERC20Token(
    ChainId.BSC,
    '0xd32d01A43c869EdcD1117C640fBDcfCFD97d9d65',
    18,
    'NMX',
    'Nominex Token',
    'https://nominex.io/',
  ),
  sand: new ERC20Token(
    ChainId.BSC,
    '0x67b725d7e342d7B611fa85e859Df9697D9378B2e',
    18,
    'SAND',
    'The Sandbox',
    'https://sandbox.game/',
  ),
  shib: new ERC20Token(
    ChainId.BSC,
    '0x2859e4544C4bB03966803b044A93563Bd2D0DD4D',
    18,
    'SHIB',
    'Binance-Peg SHIBA INU Token',
    'https://shibatoken.com/',
  ),
  sol: new ERC20Token(
    ChainId.BSC,
    '0x570A5D26f7765Ecb712C0924E4De545B89fD43dF',
    18,
    'SOL',
    'Solana',
    'https://solana.com/',
  ),
  trx: new ERC20Token(
    ChainId.BSC,
    '0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B',
    18,
    'TRX',
    'TRON',
    'https://tron.network/',
  ),
  toncoin: new ERC20Token(
    ChainId.BSC,
    '0x76A797A59Ba2C17726896976B7B3747BfD1d220f',
    9,
    'TONCOIN',
    'Wrapped TON Coin',
    'https://ton.org/',
  ),
  twt: new ERC20Token(
    ChainId.BSC,
    '0x4B0F1812e5Df2A09796481Ff14017e6005508003',
    18,
    'TWT',
    'Trust Wallet Token',
    'https://trustwallet.com/',
  ),
  uni: new ERC20Token(
    ChainId.BSC,
    '0xBf5140A22578168FD562DCcF235E5D43A02ce9B1',
    18,
    'UNI',
    'Binance-Peg Uniswap Token',
    'https://uniswap.org/',
  ),
  usdc: new ERC20Token(
    ChainId.BSC,
    '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    18,
    'USDC',
    'Binance-Peg USD Coin',
    'https://centre.io/usdc',
  ),
  usdt: new ERC20Token(
    ChainId.BSC,
    '0x55d398326f99059fF775485246999027B3197955',
    18,
    'USDT',
    'Tether USD',
    'https://tether.to/',
  ),
  wbnb: WBNB[ChainId.BSC],
  xrp: new ERC20Token(
    ChainId.BSC,
    '0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE',
    18,
    'XRP',
    'Binance-Peg XRP Token',
    'https://ripple.com/xrp/',
  ),
}
